import { createElementBlock as e, defineComponent as t, guardReactiveProps as n, normalizeProps as r, openBlock as i, renderSlot as a } from "vue";
import "@awesome.me/webawesome-pro/dist/components/dialog/dialog.js";
// src/components/DsDialog.vue?vue&type=script&setup=true&lang.ts
var o = /*@__PURE__*/ t({
	__name: "DsDialog",
	setup(t) {
		return (t, o) => (i(), e("wa-dialog", r(n(t.$attrs)), [a(t.$slots, "default")], 16));
	}
});
export { o as default };

//# sourceMappingURL=DsDialog.vue_vue_type_script_setup_true_lang.js.map